<template>
  <div>
    <input @change="updateFilter" v-model="value" placeholder="Данные для поиска" type="text" class="form-control">
  </div>
</template>

<script>


  export default {
    components: {
    },
    props: ['type', 'updateFilter'],
    data() {
      return {
        value: null,
      }
    },
    methods: {
    }
  }

</script>

<style scoped>
  .hidden_calc {
    width: 0px;
    height: 0px;
  }

</style>
<style>
  .hidden_calc .mx-input-wrapper {
    display: none;
  }
</style>
